import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IAddOnCommand, IProductAddOn } from "../products";

export default class AddOnStore {
  addOns: Array<IProductAddOn> = [];
  editAddOn: IProductAddOn | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchAddOns = () => {
    const url = ApiConfig.REST_URIS.addOn.fetchAddOns;
    Api.get(url, (res: ApiResponse<IProductAddOn[]>) => {
      if (res?.isSuccess && res.data) {
        this.addOns = _.sortBy(res.data, "addOnName");
      }
    });
  };

  saveAddOn = (addOn: IAddOnCommand, callback: Function) => {
    if (addOn.addOnId) {
      Api.put(
        ApiConfig.REST_URIS.addOn.update(addOn.addOnId),
        addOn,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.addOn.create,
        addOn,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    }
  };

  deleteAddOn = (addOnId: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.addOn.delete(addOnId);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditAddOn = (addOn: IProductAddOn | null) => {
    this.editAddOn = addOn;
  };
}
